export const GET_SCHOOL_DATA_REQUESTED = "GET_SCHOOL_DATA_REQUESTED"
export const GET_SCHOOL_DATA_SUCCESSFUL = "GET_SCHOOL_DATA_SUCCESSFUL"
export const GET_SCHOOL_DATA_FAILED = "GET_SCHOOL_DATA_FAILED"
export const GET_SCHOOL_COURSES_REQUESTED = "GET_SCHOOL_COURSES_REQUESTED"
export const GET_SCHOOL_COURSES_SUCCESSFUL = "GET_SCHOOL_COURSES_SUCCESSFUL"
export const GET_SCHOOL_COURSES_FAILED = "GET_SCHOOL_COURSES_FAILED"
export const GET_COURSE_DETAILS_REQUESTED = "GET_COURSE_DETAILS_REQUESTED"
export const GET_COURSE_DETAILS_SUCCESSFUL = "GET_COURSE_DETAILS_SUCCESSFUL"
export const GET_COURSE_DETAILS_FAILED = "GET_COURSE_DETAILS_FAILED"
export const GET_COURSE_MODULES_REQUESTED = "GET_COURSE_MODULES_REQUESTED"
export const GET_COURSE_MODULES_SUCCESSFUL = "GET_COURSE_MODULES_SUCCESSFUL"
export const GET_COURSE_MODULES_FAILED = "GET_COURSE_MODULES_FAILED"
export const GET_SOCIALS_REQUESTED = "GET_SOCIALS_REQUESTED"
export const GET_SOCIALS_SUCCESSFUL = "GET_SOCIALS_SUCCESSFUL"
export const GET_SOCIALS_FAILED = "GET_SOCIALS_FAILED"
export const GET_FORUMS_REQUESTED = "GET_FORUMS_REQUESTED"
export const GET_FORUMS_SUCCESSFUL = "GET_FORUMS_SUCCESSFUL"
export const GET_FORUMS_FAILED = "GET_FORUMS_FAILED"
export const SET_FORUMS_DATA = "SET_FORUMS_DATA"
export const GET_FORUMS_SUMMARY_REQUESTED = "GET_FORUMS_SUMMARY_REQUESTED"
export const GET_FORUMS_SUMMARY_SUCCESSFUL = "GET_FORUMS_SUMMARY_SUCCESSFUL"
export const GET_FORUMS_SUMMARY_FAILED = "GET_FORUMS_SUMMARY_FAILED"
export const GET_FORUMS_UNANSWERED_REQUESTED = "GET_FORUMS_UNANSWERED_REQUESTED"
export const GET_FORUMS_UNANSWERED_SUCCESSFUL =
  "GET_FORUMS_UNANSWERED_SUCCESSFUL"
export const GET_FORUMS_UNANSWERED_FAILED = "GET_FORUMS_UNANSWERED_FAILED"
export const SET_FORUMS_UNANSWERED_DATA = "SET_FORUMS_UNANSWERED_DATA"

export const GET_QUESTION_DATA_REQUESTED = "GET_QUESTION_DATA_REQUESTED"
export const GET_QUESTION_DATA_SUCCESSFUL = "GET_QUESTION_DATA_SUCCESSFUL"
export const GET_QUESTION_DATA_FAILED = "GET_QUESTION_DATA_FAILED"

export const SHOW_FORUM_MODAL = "SHOW_FORUM_MODAL"
export const HIDE_FORUM_MODAL = "HIDE_FORUM_MODAL"

export const SET_FORUMS_ERROR = "SET_FORUMS_ERROR"

export const SUBMIT_FORUM_QUESTION_REQUESTED = "SUBMIT_FORUM_QUESTION_REQUESTED"
export const SUBMIT_FORUM_QUESTION_SUCCESSFUL =
  "SUBMIT_FORUM_QUESTION_SUCCESSFUL"
export const SUBMIT_FORUM_QUESTION_FAILED = "SUBMIT_FORUM_QUESTION_FAILED"

export const SUBMIT_FORUM_COMMENT_REQUESTED = "SUBMIT_FORUM_COMMENT_REQUESTED"
export const SUBMIT_FORUM_COMMENT_SUCCESSFUL = "SUBMIT_FORUM_COMMENT_SUCCESSFUL"
export const SUBMIT_FORUM_COMMENT_FAILED = "SUBMIT_FORUM_COMMENT_FAILED"

export const SUBMIT_FORUM_ANSWER_REQUESTED = "SUBMIT_FORUM_ANSWER_REQUESTED"
export const SUBMIT_FORUM_ANSWER_SUCCESSFUL = "SUBMIT_FORUM_ANSWER_SUCCESSFUL"
export const SUBMIT_FORUM_ANSWER_FAILED = "SUBMIT_FORUM_ANSWER_FAILED"

export const UPVOTE_FORUM_QUESTION_REQUESTED = "UPVOTE_FORUM_QUESTION_REQUESTED"
export const UPVOTE_FORUM_QUESTION_SUCCESSFUL =
  "UPVOTE_FORUM_QUESTION_SUCCESSFUL"
export const UPVOTE_FORUM_QUESTION_FAILED = "UPVOTE_FORUM_QUESTION_FAILED"

export const DOWNVOTE_FORUM_QUESTION_REQUESTED =
  "DOWNVOTE_FORUM_QUESTION_REQUESTED"
export const DOWNVOTE_FORUM_QUESTION_SUCCESSFUL =
  "DOWNVOTE_FORUM_QUESTION_SUCCESSFUL"
export const DOWNVOTE_FORUM_QUESTION_FAILED = "DOWNVOTE_FORUM_QUESTION_FAILED"

export const UPVOTE_FORUM_ANSWER_REQUESTED = "UPVOTE_FORUM_ANSWER_REQUESTED"
export const UPVOTE_FORUM_ANSWER_SUCCESSFUL = "UPVOTE_FORUM_ANSWER_SUCCESSFUL"
export const UPVOTE_FORUM_ANSWER_FAILED = "UPVOTE_FORUM_ANSWER_FAILED"

export const DOWNVOTE_FORUM_ANSWER_REQUESTED = "DOWNVOTE_FORUM_ANSWER_REQUESTED"
export const DOWNVOTE_FORUM_ANSWER_SUCCESSFUL =
  "DOWNVOTE_FORUM_ANSWER_SUCCESSFUL"
export const DOWNVOTE_FORUM_ANSWER_FAILED = "DOWNVOTE_FORUM_ANSWER_FAILED"

export const SET_FORUM_ANSWER_LIST = "SET_FORUM_ANSWER_LIST"
export const SET_FORUM_COMMENT_LIST = "SET_FORUM_COMMENT_LIST"
export const SET_FORUM_LATEST_LIST = "SET_FORUM_LATEST_LIST"
export const SET_FORUM_UNANSWERED_LIST = "SET_FORUM_QUESTION_LIST"

export const UPDATE_FORUM_QUESTION_REQUESTED = "UPDATE_FORUM_QUESTION_REQUESTED"
export const UPDATE_FORUM_QUESTION_SUCCESSFUL =
  "UPDATE_FORUM_QUESTION_SUCCESSFUL"
export const UPDATE_FORUM_QUESTION_FAILED = "UPDATE_FORUM_QUESTION_FAILED"

export const UPDATE_FORUM_ANSWER_REQUESTED = "UPDATE_FORUM_ANSWER_REQUESTED"
export const UPDATE_FORUM_ANSWER_SUCCESSFUL = "UPDATE_FORUM_ANSWER_SUCCESSFUL"
export const UPDATE_FORUM_ANSWER_FAILED = "UPDATE_FORUM_ANSWER_FAILED"

export const UPDATE_FORUM_COMMENT_REQUESTED = "UPDATE_FORUM_COMMENT_REQUESTED"
export const UPDATE_FORUM_COMMENT_SUCCESSFUL = "UPDATE_FORUM_COMMENT_SUCCESSFUL"
export const UPDATE_FORUM_COMMENT_FAILED = "UPDATE_FORUM_COMMENT_FAILED"

export const SET_FORUM_QUESTION_DATA = "SET_FORUM_QUESTION_DATA"
export const SET_FORUM_ANSWER_DATA = "SET_FORUM_ANSWER_DATA"
export const SET_FORUM_COMMENT_DATA = "SET_FORUM_COMMENT_DATA"

export const SEARCH_FORUMS_TAG_REQUESTED = "SEARCH_FORUMS_TAG_REQUESTED"
export const SEARCH_FORUMS_TAG_SUCCESSFUL = "SEARCH_FORUMS_TAG_SUCCESSFUL"
export const SEARCH_FORUMS_TAG_FAILED = "SEARCH_FORUMS_TAG_FAILED"

export const SEARCH_FORUMS_REQUESTED = "SEARCH_FORUMS_REQUESTED"
export const SEARCH_FORUMS_SUCCESSFUL = "SEARCH_FORUMS_SUCCESSFUL"
export const SEARCH_FORUMS_FAILED = "SEARCH_FORUMS_FAILED"

export const ACCEPT_FORUM_ANSWER_REQUESTED = "ACCEPT_FORUM_ANSWER_REQUESTED"
export const ACCEPT_FORUM_ANSWER_SUCCESSFUL = "ACCEPT_FORUM_ANSWER_SUCCESSFUL"
export const ACCEPT_FORUM_ANSWER_FAILED = "ACCEPT_FORUM_ANSWER_FAILED"

export const CLOSE_FORUM_QUESTION_REQUESTED = "CLOSE_FORUM_QUESTION_REQUESTED"
export const CLOSE_FORUM_QUESTION_SUCCESSFUL = "CLOSE_FORUM_QUESTION_SUCCESSFUL"
export const CLOSE_FORUM_QUESTION_FAILED = "CLOSE_FORUM_QUESTION_FAILED"

export const ADD_ANSWER_COMMENT_REQUESTED = "ADD_ANSWER_COMMENT_REQUESTED"
export const ADD_ANSWER_COMMENT_SUCCESSFUL = "ADD_ANSWER_COMMENT_SUCCESSFUL"
export const ADD_ANSWER_COMMENT_FAILED = "ADD_ANSWER_COMMENT_FAILED"

export const EDIT_ANSWER_COMMENT_REQUESTED = "EDIT_ANSWER_COMMENT_REQUESTED"
export const EDIT_ANSWER_COMMENT_SUCCESSFUL = "EDIT_ANSWER_COMMENT_SUCCESSFUL"
export const EDIT_ANSWER_COMMENT_FAILED = "EDIT_ANSWER_COMMENT_FAILED"

export const GET_SCHOOL_DATA_BY_DOMAIN_REQUESTED =
  "GET_SCHOOL_DATA_BY_DOMAIN_REQUESTED"
export const GET_SCHOOL_DATA_BY_DOMAIN_SUCCESSFUL =
  "GET_SCHOOL_DATA_BY_DOMAIN_SUCCESSFUL"
export const GET_SCHOOL_DATA_BY_DOMAIN_FAILED =
  "GET_SCHOOL_DATA_BY_DOMAIN_FAILED"
